import './campaign-action-log.component.scss'
import {Pageable} from "../../../utils/models/Page";
import {IController, IOnChangesObject} from "angular";
import {CampaignActionLog} from "../../../campaigns_service/model/CampaignActionLog";
import {Customer} from "../../../customers/model/Customer";


export class CampaignActionLogComponent implements IController {

    static instance = {
        template: require('./campaign-action-log.component.html'),
        controller: [
            CampaignActionLogComponent
        ],
        bindings: {
            customer: '<',
            pagingConfig: '<',
            logs: '<',
            fetchLogs: '<'
        }
    };

    private pagingConfig: Pageable;

    private logs: CampaignActionLog[];

    private fetchLogs: () => void;

    private customer: Customer;

    constructor() {
    }

    $onChanges(onChangesObj: IOnChangesObject): void {
        this.listenToPropCahnges(onChangesObj, 'logs', (logs: CampaignActionLog[]) => this.logs = logs);
        this.listenToPropCahnges(onChangesObj, 'pagingConfig', (pagingConfig: Pageable) => this.pagingConfig = pagingConfig);
    }

    private listenToPropCahnges<T>(onChangesObj: IOnChangesObject, propName: string, callback: (change: T) => void) {
        var popChange = onChangesObj[propName];
        if (popChange && !popChange.isFirstChange()) {
            callback(popChange.currentValue);
        }
    }

}